import { PagingInfo } from './PagingInfo';

export interface DataRoomActivityLog {
	paging: PagingInfo;
	logs: ActivityLog[];
}

export interface ActivityLog {
	id: number;
	statObjectType?: StatObjectTypes;
	userHostAddress: string;
	urlReferrer: string;
	performedByName: string;
	extras: string;
	createdOn?: Date;
}

export type StatObjectTypes = keyof typeof StatObjectTypesMap;
export const StatObjectTypesMap = {
	FailedLogin: 'Failed Login',
	Search: 'Search',
	LoginNoUsernameFound: 'Login Failed from No Username Found',
	LoginFailedAttempt: 'Login Failed Attempt',
	LoginAttemptLockOut: 'Locked Out from Failed Attempts',
	EmailBlocked: 'Email Blocked',
	EmailBounced: 'Email Bounced',
	EmailUnsubscribe: 'Email Unsubscribe',
	EmailSpamReport: 'Email Spam Report',
	OverAuthorization: 'Over Authorization',
	NewUser: 'New User',
	PasswordReset: 'Password Reset',
	CompanyUpdated: 'Company Updated',
	CompanyAdded: 'Company Added',
	CompanyOfficeUpdated: 'Company Office Updated',
	CompanyContactUpdated: 'Company Contact Updated',
	CompanyDocumentAdded: 'Company Document Added',
	CompanyFinancialsAdded: 'Company Financials Added',
	CompanyFinancialsUpdated: 'Company Financials Updated',
	NewDealCreated: 'New Deal Created',
	DealModified: 'Deal Modified',
	BankAdded: 'Bank Added',
	BankDocumentAdded: 'Bank Document Added',
	BankOfficeUpdated: 'Bank Office Updated',
	BankContactUpdated: 'Bank Contact Updated',
	BankUpdated: 'Bank Updated',
	DealProfileUpdated: 'Deal Profile Updated',
	NewLoanCreated: 'New Loan Created',
	LoanModified: 'Loan Modified',
	AccessDataRoom: 'Access Data Room',
	ViewDataRoomDocument: 'View Data Room Document',
	NonFinancialCovenantAdded: 'Non-Financial Covenant Added',
	NonFinancialCovenantModified: 'Non-Financial Covenant Modified',
	FinancialCovenantAdded: 'Financial Covenant Added',
	FinancialCovenantModified: 'Financial Covenant Modified',
	FinancialCovenantTargetCreated: 'Financial Covenant Target Created',
	FinancialCovenantTargetModified: 'Financial Covenant Target Modified',
	FinancialStatementModified: 'Financial Statement Modified',
	FinancialStatementCreated: 'Financial Statement Created',
	DealAccessLink: 'Deal Access Link',
	DataRoomInviteSent: 'Data Room Invite Sent',
	DataRoomUpdated: 'Data Room Updated',
	CreditSearchAgreementSigned: 'Credit Search Agreement Signed',
	DataRoomAccessed: 'Data Room Accessed',
	LoanCovenantsApproved: 'Loan Covenants Approved',
	LoanCovenantsReset: 'Loan Covenants Reset',
	LoanCovenantsLevel4Approval: 'Loan Covenants Level 4 Approval',
	LoanCovenantsLevel1Approval: 'Loan Covenants Level 1 Approval',
	LoanCovenantsLevel2Approval: 'Loan Covenants Level 2 Approval',
	LoanCovenantsLevel3Approval: 'Loan Covenants Level 3 Approval',
	DataRoomAgreementAccepted: 'Data Room Agreement Accepted',
	DiscountAdded: 'Discount Added',
	DiscountModified: 'Discount Modified',
	ProductAdded: 'Product Added',
	ProductModified: 'Product Modified',
	CompanyProductTermAdded: 'Company Product Term Added',
	CompanyProductTermModified: 'Company Product Term Modified',
	AddInvoicePayment: 'Add Invoice Payment',
	InvoiceDownloaded: 'Invoice Downloaded',
	SubscriptionAgreementDownloaded: 'Subscription Agreement Downloaded',
	CreditFacilityDeleted: 'Credit Facility Deleted',
	CreditFacilitySoftDeleted: 'Credit Facility Soft Deleted',
	ThirdPartyCompanyContactUpdated: '3rd Party Company Contact Updated',
	AwsS3FileMissing: 'AWS S3 File Missing',
	DataRoomContactUpdated: 'Data Room Updated 3rd Party Contact Status',
	DataRoomContactAdded: 'Data Room Added 3rd Party Company Contact',
	BankContactTeamMemberSaved: 'Bank Contact Team Member Saved',
	DownloadAllDataRoomFiles: 'Download All Data Room Files',
	DownloadAllCompanyFiles: 'Download All Company Files',
	ExpressLoanAndDocumentsUploaded: 'Express Loan Created and Document(s) Uploaded',
	DataRoomTaskAdded: 'Data Room Task Added',
	DataRoomTaskUpdated: 'Data Room Task Updated',
	DataRoomTaskStatusChanged: 'Data Room Task Status Changed',
	DataRoomTaskAssigned: 'Data Room Task Assigned',
	DataRoomTaskDeleted: 'Data room task deleted',
	DataRoomTaskCompleted: 'Data room task completed',
	DataRoomNoteAdded: 'Data room note added',
	DataRoomNoteUpdated: 'Data room note updated',
	DataRoomNoteDeleted: 'Data room note deleted',
	DataRoomEmailSent: 'Data room email sent',
	DataRoomEmailResent: 'Data room email resent',
	DataRoomMilestoneAdded: 'Data room milestone added',
	DataRoomMilestoneUpdated: 'Data room milestone updated',
	DataRoomMilestoneDeleted: 'Data room milestone deleted',
	LoanAgreementSoftDeleted: 'Loan Agreement Soft Deleted',
	LoanAgreementDeleted: 'Loan Agreement Deleted',
	AddTermSheet: 'Add Term Sheet',
	AddTermSheetRevision: 'Add Term Sheet Revision',
	ApproveTermSheet: 'Approve Term Sheet',
	DeclineTermSheet: 'Decline Term Sheet',
	FinancialCovenantTargetDeleted: 'Financial Covenant Target Deleted',
	CovenantPeriodFormulaAdded: 'Covenant Period Formula Added',
	DataRoomDocumentAdded: 'Data Room Document Added',
	DataRoomDocumentAddExisting: 'Added Existing Document to Data Room',
	LenderDataRoomNewDocumentAlert: 'New Data Room Document Alert Sent to Lender',
	DataRoomUserUpdateDeleted: 'Lender Data Room Update Deleted',
	DataRoomQuestionDeleted: 'Data Room Question Deleted',
	UserUnlocked: 'User has been Unlocked',
	DealPartnerAdded: 'Deal Partner Added',
	DealPartnerEdit: 'Deal Partner Updated',
	DownloadSelectedFiles: 'Download Selected Data Room Documents',
	DataRoomInviteReminderSent: 'Data Room Invite Reminder Sent',
	DataRoomTeaserReminderSent: 'Data Room Teaser Reminder Sent',
	LoanAgreementExtractReport: 'Loan Agreement Extract Report',
	CompanyDocumentDeleted: 'Company Document Deleted',
};
